module.exports = __webpack_public_path__ + "img/1551579915.27ccc1ac.jpg";